import { render, staticRenderFns } from "./TemplateGroupItem.vue?vue&type=template&id=390dd1e4&scoped=true"
import script from "./TemplateGroupItem.vue?vue&type=script&lang=js"
export * from "./TemplateGroupItem.vue?vue&type=script&lang=js"
import style0 from "./TemplateGroupItem.vue?vue&type=style&index=0&id=390dd1e4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390dd1e4",
  null
  
)

export default component.exports